import React, { useState } from 'react';
import { Field, Formik } from 'formik';
import Fields from 'components/Fields';
import api from 'api';
import { Button } from 'components/Base';
import * as Yup from 'yup';
import { Notify } from 'utils';

interface AboutUsProps {
  data: any;
  updateData: Function;
  classes: any;
}

const validationSchema = Yup.object().shape({
  about_us: Yup.string().nullable(),
  key_features: Yup.string().nullable()
});

const AboutUs = ({ data, updateData, classes }: AboutUsProps) => {
  const [isSaving, setIsSaving] = useState(false);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        about_us: data.computed_about_us,
        key_features: data.key_features
      }}
      onSubmit={values => {
        setIsSaving(true);

        api
          .updateMpsProvider(data.id, values)
          .then(({ data }) => {
            updateData(data);
            Notify.success('Provider information updated successfully.');
          })
          .catch(() => {
            Notify.error('Provider information could not be updated.');
          })
          .finally(() => {
            setIsSaving(false);
          });
      }}
      validationSchema={validationSchema}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit}>
            <div>
              <div className={`${classes.row} ${classes.alignBaseline}`}>
                <div className={classes.label}>About us</div>
                <div
                  className={classes.fieldWrapper}
                  style={{ maxWidth: '70%' }}
                >
                  <Field
                    style={{ background: '#fafafa' }}
                    name="about_us"
                    component={Fields.v2.WYSIWYGEditor}
                    filled
                  />
                </div>
              </div>
              <div className={`${classes.row} ${classes.alignBaseline}`}>
                <div className={classes.label}>Key features</div>
                <div
                  className={classes.fieldWrapper}
                  style={{ maxWidth: '70%' }}
                >
                  <Field
                    style={{ background: '#fafafa' }}
                    name="key_features"
                    component={Fields.v2.WYSIWYGEditor}
                    filled
                  />
                </div>
              </div>
            </div>
            <div>
              <Button type="submit" disabled={isSaving} isLoading={isSaving}>
                Save
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default AboutUs;
